<template>
    <div class="StockThresholdPanel">
        <SyPanel :title="stock.listName" :icon="stock.listType" :clickable="true" @titleClicked="viewList" :over="!stockInList">
            <template v-slot:details>
                <div v-if="showScore">
                    <StockScoreDetailsTip v-if="inABuyList" :scoreDetailsInfo="scoreDetailsInfo">
                        <div v-if="stockInList" :class="`thScore ${getScoreColor()}`">{{getCleanScore()}}</div>
                    </StockScoreDetailsTip>
                    <div v-else :class="`thScore ${getScoreColor()}`">{{getCleanScore()}}</div>
                </div>
            </template>
            <ThresholdPanel v-if="stockInList" :stock="stock" :stockListId="stock.listId" class="thPanel"></ThresholdPanel>
            <!-- <ThresholdPanel v-if="showAddNewThreshold" :stock="stock" :stockListId="stock.listId" class="thPanel"></ThresholdPanel> -->
            <div v-else class="empty">
                <v-btn text color="agora" @click="addSymbol">
                    <font-awesome-icon :icon="icons.add" class="fa-fw fa-lg mr-2"></font-awesome-icon>
                    {{ $t('UserStockWatchingList.emptyList.addSymbol') }}
                </v-btn>
            </div>
            <template v-slot:footer v-if="stockInList">
                <v-btn color="red" text small dark @click="deleteEntry" class="deleteButton">
                    <font-awesome-icon :icon="icons.delete" class="fa-fw fa-lg mr-2"></font-awesome-icon>
                    {{ buttonLabel }}
                </v-btn>
            </template>
        </SyPanel>
        <ConfirmDialog ref="deleteItemConfirmDialog" @answered="deleteItemDialogAnswered"></ConfirmDialog>
        <Alert ref="iAlert"></Alert>
    </div>
</template>

<script>
import ThresholdPanel from './edition/ThresholdPanel.vue'
import SyPanel from '../controls/SyPanel.vue'
import Alert from '../controls/Alert.vue';
import ConfirmDialog from '../controls/ConfirmDialog.vue';
import { faPlus, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import StockHtmlHelper from '../stocks/StockHtmlHelper';
import StockScoreDetailsTip from '../stocks/stockScoreDetails/StockScoreDetailsTip.vue';
export default {
    components: { ThresholdPanel, SyPanel, Alert, ConfirmDialog, StockScoreDetailsTip },
    props: ["stock"],
    data() {
        return {
            icons: {
                add: faPlus,
                delete: faTrashAlt
            },
            showAddNewThreshold: false
        }
    },
    created() {
        this.stockHtmlHelper = new StockHtmlHelper();
    },
    computed: {
        buttonLabel() {
            if (this.$vuetify.breakpoint.mobile) {
                return this.$t('UserStockWatchingList.buttons.removeFromList')
            }
            else {
                return this.$t('UserStockWatchingList.buttons.deleteFromList', [this.stock.symbol, this.stock.listName])
            }
        },
        stockInList() {
            return this.stock.listId;
        },
        scoreDetailsInfo() {
            return this.stock.scoreDetailsInfo;
        },
        inABuyList() {
            return this.stock.listType === 'buy';
        },
        showScore() {
            return this.stock.score;
        }
    },
    methods: {
        getCleanScore() {
            if (!this.stock.score) return '';
            return this.stockHtmlHelper.cleanScore(this.stock.score);
        },
        getScoreColor() {
            return this.stockHtmlHelper.getBadgeColor(this.stockHtmlHelper.getBadge(this.stock.score));
        },
        addSymbol() {
            console.log('addSymbol', this.stock);
            if (this.stock.listType === 'sell') {
                this.showAddNewThreshold = true;
                return;
            }
            const item = this.stock.rawData;
            item.plateformCustomExchange = item.exchange;

            this.$store.dispatch('addStockInWatchList', { listId: this.stock.id, item, listType: this.stock.listType }).then(() => {
                console.log('addStockInWatchList done');
            }).catch(error => {
                this.$refs.iAlert.error(error[0]);
            });
        },
        deleteEntry() {
            this.$refs.deleteItemConfirmDialog.open({
                title: this.$t('EditorPanel.actions.deleteItem.title'),
                text: this.$t('EditorPanel.actions.deleteItem.text', [this.stock.symbol, this.stock.listName])
            })
        },
        deleteItemDialogAnswered(answer) {
            if (answer.response === true) {
                this.$store.dispatch('deleteStockFromWatchList', { listId: this.stock.listId, entryId: this.stock.id, listType: this.stock.listType }).then(() => {
                    console.log('deleteStockFromWatchList done');
                }).catch(error => {
                    this.$refs.iAlert.error(error[0]);
                });
            }
        },
        viewList() {
            this.$router.push({ name: 'List', params: { id: this.stock.listId } });
        }
    }
}
</script>

<style lang="scss" scoped>
.StockThresholdPanel {
    position: relative;
    .thScore {
        display: flex;
        align-items: center;
        font-weight: bold;
        color: var(--t000);
        background-color: var(--t000-bg);
        line-height: 1.2;
        font-size: 1.5em;
        padding: 0 10px;
        border-radius: 50px;
        &.t600{
            color: var(--t600);
            background-color: var(--t600-bg);
        }
        &.t800{
            color: var(--t800);
            background-color: var(--t800-bg);
        }
        &.t400-sell {
            color: var(--t400-sell);
            background-color: var(--t400-sell-bg);
        }
        &.t200-sell {
            color: var(--t200-sell);
            background-color: var(--t200-sell-bg);
        }
        &::after {
            margin-left: 5px;
            content: "pts";
            font-size: 1rem;
            font-weight: normal;
        }
    }
    .empty {
        background-color: var(--v-lightGrayBG-base);
    }
}
</style>